import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMaytagComponent } from './simple-icons-maytag.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMaytagComponent ],
    exports:      [ SimpleIconsMaytagComponent ],
    bootstrap:    []
})
export class SimpleIconsMaytagModule {}
